














































































import API from '../api/api';
import Spinner from 'vue-simple-spinner';
import Vue from 'vue';
function truncate(stringInput: string, n: number): string {
  if (stringInput.length > n) {
    return stringInput.substring(0, n) + '...';
  } else {
    return stringInput;
  }
}
class SearchStuff {
  public inSearchMode: boolean = false;
  public results: any[] = [];
  public hadNoResults: boolean = false;
  public query: string = '';
  public isLoading: boolean = false;
  public hadError: boolean = false;

  public reset() {
    this.results = [];
    this.hadNoResults = false;
    this.query = '';
    this.isLoading = false;
    this.hadError = false;
  }
}
export default Vue.extend({
  name: 'EditorStage1',
  components: { Spinner },
  props: {
    sourceData: {
      type: Object,
      default: null,
    },
    sourceInfo: {
      type: Object,
      default: null,
    },
    parentIsLoading: {
      type: Boolean,
      default: false,
    },
  },
  data(): {
    search: SearchStuff;
  } {
    return {
      search: new SearchStuff(),
    };
  },
  mounted() {
    this.checkIfNeedsToBeInSearchMode();
  },
  watch: {
    sourceData() {
      this.checkIfNeedsToBeInSearchMode();
    },
    sourceInfo() {
      this.checkIfNeedsToBeInSearchMode();
    },
  },
  methods: {
    checkIfNeedsToBeInSearchMode() {
      if (!this.sourceData && !this.sourceInfo) {
        this.startSearchMode();
      } else {
        this.cancelSearchMode();
      }
    },
    startSearchMode() {
      this.search.reset();
      this.search.inSearchMode = true;
      this.$emit('updateEditingStatus', true);
    },
    runSearch() {
      this.search.isLoading = true;
      API.search(this.search.query)
        .then((response) => {
          console.log({ response })
          this.search.isLoading = false;
          if (response.data.resultCount) {
            this.search.results = response.data.results
              .map((result: any) => {
                return {
                  ...result,
                  thumbnail: result.artworkUrl600 || result.artworkUrl100 || result.artworkUrl60 ||
                    result.artworkUrl30 || null
                };
              });
            this.search.hadNoResults = true;
          } else if (response.data.resultCount === 0) {
            this.search.results = [];
            this.search.hadNoResults = true;
          }
        });
    },
    selectResult(result: any) {
      // TODO - actually save this via the API before emitting the change upward
      this.$emit('updateSourceData', {
        rssFeedURL: result.feedUrl,
      });
      this.$emit('updateSourceInfo', {
        title: result.title_original,
        description: result.description_original,
        thumbnail: result.thumbnail,
      });
      // this.cancelSearchMode(); // This will occur when the props are updated, as there is a watcher for this change
    },
    cancelSearchMode() {
      this.search.reset();
      this.search.inSearchMode = false;
      this.$emit('updateEditingStatus', false);
    },
  },
});
